/** Trang Public Site Content (/growth/site-content) — quản lý tuyển dụng + blog cho supernovajsc.com. */
export const siteContent: Record<string, string> = {
  'nav.growth.siteContent': 'Nội dung & Truyền thông',
  'siteContent.tabs.jobs': 'Tin tuyển dụng',
  'siteContent.tabs.blog': 'Bài viết Blog',
  'siteContent.tabs.activities': 'Hoạt động',
  'siteContent.tabs.events': 'Sự kiện',
  'siteContent.tabs.teamBuilding': 'Team Building',
  'siteContent.tabs.notify': 'Thông báo',
  'siteContent.notify.intro': 'Gửi thông báo tới chuông trên header (và điện thoại của người đã bật push). Không hẹn giờ, không sửa sau khi gửi.',
  'siteContent.notify.title': 'Tiêu đề',
  'siteContent.notify.body': 'Nội dung',
  'siteContent.notify.url': 'Đường dẫn khi bấm "Mở" (tuỳ chọn, ví dụ /leave)',
  'siteContent.notify.send': 'Gửi thông báo',
  'siteContent.notify.confirm': 'Gửi thông báo này tới nhóm đã chọn?',
  'siteContent.notify.sent': 'Đã ghi vào chuông {people} người, đẩy push tới {devices} thiết bị.',
  'siteContent.notify.log': 'Đã gửi',
  'siteContent.notify.logPeople': 'Người',
  'siteContent.notify.logDevices': 'Thiết bị',
  'siteContent.event.add': 'Thêm sự kiện',
  'siteContent.event.from': 'Hiển thị từ ngày',
  'siteContent.event.to': 'Đến ngày',
  'siteContent.event.body': 'Nội dung',
  'siteContent.event.department': 'Phòng ban',
  'siteContent.event.deptAll': 'Tất cả phòng ban',
  'siteContent.event.target': 'Gửi tới',
  'siteContent.event.targetAdmins': 'Admin',
  'siteContent.event.targetDept': 'Phòng ban',
  'siteContent.event.targetPeople': 'Người cụ thể',
  'siteContent.event.people': 'người',
  'siteContent.event.searchPeople': 'Tìm theo tên / email / mã NV...',
  'siteContent.event.schedulePush': 'Hẹn giờ push',
  'siteContent.event.scheduledFor': 'hẹn',
  'siteContent.event.clearSchedule': 'Huỷ hẹn',
  'siteContent.event.header': 'Tiêu đề popup (header)',
  'siteContent.event.pushLogs': 'Lịch sử push',
  'siteContent.event.subDraft': 'Nháp',
  'siteContent.event.subScheduled': 'Hẹn giờ',
  'siteContent.event.subPushed': 'Đã push',
  'siteContent.event.logTime': 'Thời gian',
  'siteContent.event.logSent': 'Thiết bị',
  'siteContent.event.logBy': 'Người bắn',
  'siteContent.event.logScheduled': 'Hẹn giờ',
  'siteContent.event.push': 'Push to System',
  'siteContent.event.pushConfirm': 'Đẩy sự kiện này tới thiết bị của phòng ban đích?',
  'siteContent.event.pushSent': 'Đã gửi tới {n} thiết bị',
  'siteContent.event.pushedAt': 'đã push lúc',
  'event.popupTag': 'Sự kiện công ty',
  'siteContent.addActivity': 'Thêm hoạt động',
  'siteContent.field.activityDate': 'Ngày diễn ra',
  'siteContent.field.description': 'Mô tả',
  'siteContent.field.images': 'Ảnh',
  'siteContent.field.imagesHint': 'Tự nén WebP: bản chính 1024px + thumbnail 360px.',
  'siteContent.uploading': 'Đang tải lên…',
  'siteContent.empty.activities': 'Chưa có hoạt động.',
  'siteContent.publish': 'Publish ra supernovajsc.com',
  'siteContent.publishConfirm': 'Publish toàn bộ tin tuyển dụng + bài blog đã đăng ra supernovajsc.com?',
  'siteContent.publishDone': 'Đã publish: {jobs} vị trí, {posts} bài viết.',
  'siteContent.addJob': 'Thêm vị trí',
  'siteContent.addPost': 'Thêm bài viết',
  'siteContent.save': 'Lưu',
  'siteContent.cancel': 'Huỷ',
  'siteContent.delete': 'Xoá',
  'siteContent.deleteConfirm': 'Xoá mục này?',
  'siteContent.recruiting': 'Đang tuyển',
  'siteContent.from': 'Từ ngày',
  'siteContent.to': 'Đến ngày',
  'siteContent.noBound': 'bỏ trống = không giới hạn',
  'siteContent.col.title': 'Tiêu đề',
  'siteContent.col.dept': 'Phòng ban',
  'siteContent.col.location': 'Địa điểm',
  'siteContent.col.type': 'Hình thức',
  'siteContent.col.salary': 'Mức lương',
  'siteContent.col.status': 'Trạng thái',
  'siteContent.col.category': 'Chuyên mục',
  'siteContent.col.publishedAt': 'Ngày đăng',
  'siteContent.field.summary': 'Mô tả ngắn',
  'siteContent.field.workHours': 'Giờ làm việc',
  'siteContent.field.salaryFull': 'Mức lương (đầy đủ)',
  'siteContent.field.responsibilities': 'Mô tả công việc',
  'siteContent.field.requirements': 'Yêu cầu',
  'siteContent.field.niceToHave': 'Ưu tiên',
  'siteContent.field.benefitsList': 'Quyền lợi',
  'siteContent.field.lineHint': 'Các ô danh sách: mỗi dòng 1 mục.',
  'siteContent.field.applySubject': 'Subject email ứng tuyển',
  'siteContent.field.excerpt': 'Tóm tắt',
  'siteContent.field.content': 'Nội dung bài viết',
  'siteContent.field.thumbEmoji': 'Emoji thumbnail',
  'siteContent.field.thumbTint': 'Màu thumbnail',
  'siteContent.status.open': 'Đang tuyển',
  'siteContent.status.scheduled': 'Chưa mở',
  'siteContent.status.expired': 'Hết hạn',
  'siteContent.status.off': 'Tắt',
  'siteContent.status.draft': 'Nháp',
  'siteContent.status.published': 'Đã đăng',
  'siteContent.empty.jobs': 'Chưa có tin tuyển dụng.',
  'siteContent.empty.posts': 'Chưa có bài viết.',
  'siteContent.loadError': 'Không tải được dữ liệu.',
  'siteContent.saveError': 'Lưu thất bại.',
  'siteContent.edit': 'Sửa',
}
